import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCloudTransfer: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCloudTransfer"><Path d="M13.05 18.4998H6.75C3.8505 18.4998 1.5 16.1493 1.5 13.2498C1.5 10.5904 3.47732 8.39288 6.04196 8.04714C6.89331 5.57554 9.23928 3.7998 12 3.7998C15.4794 3.7998 18.3 6.62041 18.3 10.0998C20.6196 10.0998 22.5 11.9802 22.5 14.2998C22.5 16.6194 20.6196 18.4998 18.3 18.4998L17 18.4998" stroke="currentColor"/><Path d="M10 14.9999L13.5 18.5L10 21.9999" stroke="currentColor"/></CentralIconBase>;
});

export default IconCloudTransfer;
